import { css } from '@emotion/react'

export const WidgetTableStyles = {
  widgetTable: css({
    width: '100%',
    tableLayout: 'fixed',
    borderCollapse: 'collapse',
    padding: '0px 10px',
    borderLeft: '2px solid #f0f0f0',
    borderRight: '2px solid #f0f0f0',
    ['thead']: {
      position: 'sticky',
      top: 0
    },
    ['th']: {
      backgroundColor: '#eff3f6',
      padding: '12px 10px',
      fontSize: '12px'
    },
    ['tr']: {
      borderBottom: '1px solid #f0f0f0',
      paddingLeft: '10px'
    },
    ['td']: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      padding: '8px 10px'
    },
    ['tfoot']: { position: 'sticky', bottom: 0 }
  }),
  ellipsis: css({
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  }),
  rightAlign: css({
    textAlign: 'end'
  }),
  footer: css({
    backgroundColor: '#eff3f6',
    padding: '12px 15px',
    fontSize: '12px'
  })
}
